import { Component, Input, OnDestroy, ViewEncapsulation } from "@angular/core";
import { WtfNavigationService } from "./navigation.service";
import { Subscription } from "rxjs";
import { ObservableDataService } from "../../services/core/observable-data.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-navigation",
    templateUrl: "./navigation.component.html",
    styleUrls: ["./navigation.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class WtfNavigationComponent implements OnDestroy {
    navigationModel: any[];
    navigationModelChangeSubscription: Subscription;
    ods: ObservableDataService;

    @Input("layout") layout = "vertical";

    constructor(
        private wtfNavigationService: WtfNavigationService,
        private _ods: ObservableDataService,
        private translateService: TranslateService
    ) {
        this.ods = _ods;
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");

        this.navigationModelChangeSubscription =
            this.wtfNavigationService.onNavigationModelChange.subscribe(
                (navigationModel) => {
                    //  this.ods.loggedUser.subscribe(res => {

                    this.navigationModel = navigationModel;

                    for (let i = 0; i < this.navigationModel.length; i++) {
                        this.navigationModel[i].title =
                            this.translateService.instant(
                                this.navigationModel[i].title
                            );

                        if (this.navigationModel[i].children) {
                            for (
                                let j = 0;
                                j < this.navigationModel[i].children.length;
                                j++
                            ) {
                                this.navigationModel[i].children[j].title =
                                    this.translateService.instant(
                                        this.navigationModel[i].children[j]
                                            .title
                                    );

                                if (
                                    this.navigationModel[i].children[j].children
                                ) {
                                    for (
                                        let k = 0;
                                        k <
                                        this.navigationModel[i].children[j]
                                            .children.length;
                                        k++
                                    ) {
                                        this.navigationModel[i].children[
                                            j
                                        ].children[k].title =
                                            this.translateService.instant(
                                                this.navigationModel[i]
                                                    .children[j].children[k]
                                                    .title
                                            );
                                    }
                                }
                            }
                        }
                    } //  });
                }
            );
    }

    ngOnDestroy() {
        this.navigationModelChangeSubscription.unsubscribe();
    }
}
